import type { ReactElement } from 'react'
import { InitiativeMarker } from './markers/InitiativeMarker'
import { PinMarker } from './markers/PinMarker'
import { PlotMarker } from './markers/PlotMarker'

export type MarkerAnchor = 'bottom' | 'center'

export type MarkerType = 'pin' | 'plot' | 'initiative'

type MarkerConfig = {
  component: ReactElement
  anchor: MarkerAnchor
}

export const MARKER_CONFIG: Record<MarkerType, MarkerConfig> = {
  pin: { component: <PinMarker />, anchor: 'bottom' },
  plot: { component: <PlotMarker />, anchor: 'center' },
  initiative: { component: <InitiativeMarker />, anchor: 'center' },
}
